module.exports = __webpack_public_path__ + "img/img-eat-04.b281b461.png";